import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, Tag, Input, Icon, Tooltip } from 'antd';
import { getIn } from 'formik';

function TagInput(props) {
  const { field, form, label } = props;
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const { name, value } = field;
  const inputEl = useRef(null);

  useEffect(() => {
    if (inputVisible && inputEl.current) {
      inputEl.current.focus();
    }
  }, [inputVisible]);

  const handleClose = removedTag => {
    const tags = value.filter(tag => tag !== removedTag);
    form.setFieldValue(name, tags);
  };

  const showInput = () => {
    setInputVisible(true);
  };

  const handleInputChange = e => {
    const newValue = e.target.value.replace(/\s/g, '');
    setInputValue(newValue);
  };

  const handleInputConfirm = () => {
    if (inputValue) {
      let newTags = null;
      if (value && value.indexOf(inputValue) === -1) {
        newTags = [...value, inputValue];
      } else if (!value) {
        newTags = [inputValue];
      }

      if (newTags) {
        form.setFieldValue(name, newTags);
      }
    }

    setInputValue('');
    setInputVisible(false);
  };

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const hasError = error !== undefined && touched;
  const isValid = !error && !!touched;

  return (
    <Form.Item
      validateStatus={hasError ? 'error' : undefined}
      hasFeedback={isValid}
      label={label}
      help={(hasError && <li>{error}</li>) || (isValid && '')}
    >
      {value &&
        value.map((tag, index) => {
          const isLongTag = tag.length > 20;
          const tagElem = (
            <Tag key={tag} closable onClose={() => handleClose(tag)}>
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </Tag>
          );
          return isLongTag ? (
            <Tooltip title={tag} key={tag}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          );
        })}
      {inputVisible && (
        <Input
          ref={inputEl}
          type="text"
          size="small"
          style={{ width: 78 }}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      )}
      {!inputVisible && (
        <Tag
          onClick={showInput}
          style={{ background: '#fff', borderStyle: 'dashed' }}
        >
          <Icon type="plus" /> New
        </Tag>
      )}
    </Form.Item>
  );
}
TagInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string,
  id: PropTypes.string
};
export default TagInput;
